module.exports = __webpack_public_path__ + "img/swiperBorder.f571ac58.svg";